import * as React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { AplicacionesContainer } from "../../components/contenedor-aplicaciones/aplicaciones/AplicacionesContainer";
import { NavbarContainer } from "../../components/nav-bar/NavbarContainer";
import { SidebarContainer } from "../../components/sidebar/sidebar/SidebarContainer";
import "./portal.style.css";


const Portal = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(false);

  return (
    <Grid className="grid-home zportal">
      <Row className="row-navbar">
        <Col className="col-navbar">
          <NavbarContainer
            isSidebarCollapsed={isSidebarCollapsed}
            onToggleSidebar={() => setIsSidebarCollapsed((v) => !v)}
          />
        </Col>
      </Row>

      <Row className="row-portal-content">
        <Col
          sm={isSidebarCollapsed ? 1 : 4}
          md={isSidebarCollapsed ? 1 : 3}
          lg={isSidebarCollapsed ? 1 : 3}
          className={
            isSidebarCollapsed
              ? "col-sidebar col-sidebar-collapsed"
              : "hidden-xs col-sidebar"
          }
        >
          <SidebarContainer
            isSidebarCollapsed={isSidebarCollapsed}
            onToggleSidebar={() => setIsSidebarCollapsed((v) => !v)}
          />
        </Col>
        <Col
          sm={isSidebarCollapsed ? 11 : 8}
          md={isSidebarCollapsed ? 11 : 9}
          lg={isSidebarCollapsed ? 11 : 9}
          className={
            isSidebarCollapsed
              ? "col-aplicaciones col-aplicaciones-expanded"
              : "col-aplicaciones"
          }
        >
          <AplicacionesContainer/>
        </Col>
      </Row>
    </Grid>
  );
};
export default Portal;



// WEBPACK FOOTER //
// ./src/portal/pages/portal/Portal.tsx